// https://github.com/sindresorhus/debounce-fn
import debounce from 'debounce-fn'
export default debounce
